export default "__VITE_ASSET__az8oX9$P__"